export default __webpack_public_path__ + "static/media/GalanoGrotesque-SemiBoldItalic.b0f998cd.ttf";